import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export enum LanguageCode {
  ko = 'ko',
  en = 'en',
  ja = 'ja',
  zh = 'zh',
  zh_tw = 'zh-tw',
  ms = 'ms',
  th = 'th',
  id = 'id',
  mn = 'mn',
  ru = 'ru',
}

interface LanguageCodeStore {
  languageCode: LanguageCode;
  setLanguageCode: (languageCode: LanguageCode) => void;
}

const initialData: Omit<LanguageCodeStore, 'setLanguageCode'> = {
  languageCode: LanguageCode.ko,
};

const useLanguageCodeStore = create<LanguageCodeStore>()(
  persist<LanguageCodeStore>(
    (set) => {
      return {
        ...initialData,
        setLanguageCode: (languageCode: LanguageCode) =>
          set((state) => ({
            ...state,
            languageCode,
          })),
      };
    },
    {
      name: 'LANGUAGE_CODE_STORE',
    },
  ),
);

export default useLanguageCodeStore;
